// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { dayjs } from "@outschool/time";

import { UpcomingClassesQuery } from "../../../../../../shared/generated/graphql";
import * as Section from "../../../../../../shared/Section";

export type UpcomingClassQuerySection =
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  | UpcomingClassesQuery["publicProfile"]["leader"]["flexSections"]["edges"][0]["node"]
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  | UpcomingClassesQuery["publicProfile"]["leader"]["meetings"]["edges"][0]["node"]["section"];

export type UpcomingClassQueryActivity =
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  | UpcomingClassesQuery["publicProfile"]["leader"]["flexSections"]["edges"][0]["node"]["activity"]
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  | UpcomingClassesQuery["publicProfile"]["leader"]["meetings"]["edges"][0]["node"]["section"]["activity"];

export type NormalizedEventInfo = {
  section: UpcomingClassQuerySection;
  activity: UpcomingClassQueryActivity;
  start: Date;
  end: Date;
  isFlex: boolean;
  sellerOrgLeaderName: string | null;
  sectionSequenceNumber: number | null;
};

/** normalize flex section and meeting data */

const normalizeFlexMeeting = (
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  flexMeeting: UpcomingClassesQuery["publicProfile"]["leader"]["flexSections"]["edges"][0]["node"]
): NormalizedEventInfo => {
  const { start_time, end_time, activity } = flexMeeting;

  return {
    section: flexMeeting,
    activity,
    start: new Date(start_time),
    end: new Date(end_time),
    isFlex: true,
    sellerOrgLeaderName: flexMeeting.leader.teacherForSellerOrg
      ? flexMeeting.leader.name
      : null,
    sectionSequenceNumber: null
  };
};

const normalizeScheduledMeeting = (
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  scheduledMeeting: UpcomingClassesQuery["publicProfile"]["leader"]["meetings"]["edges"][0]["node"]
): NormalizedEventInfo => {
  const { start_time, end_time, sectionSequenceNumber, section } =
    scheduledMeeting;

  return {
    section,
    activity: section.activity,
    start: new Date(start_time),
    end: new Date(end_time),
    isFlex: false,
    sellerOrgLeaderName: section.leader.teacherForSellerOrg
      ? section.leader.name
      : null,
    sectionSequenceNumber
  };
};

export const extractAndNormalizeFlexSectionAndMeetingData = (
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  leaderData: UpcomingClassesQuery["publicProfile"]["leader"]
): NormalizedEventInfo[] => {
  const meetings =
    leaderData.meetings?.edges?.map(({ node }: $TSFixMe) => node) ?? [];
  const flexSections =
    leaderData.flexSections?.edges?.map(({ node }: $TSFixMe) => node) ?? [];

  const scheduledEvents: NormalizedEventInfo[] = meetings.reduce(
    (acc: $TSFixMe, meeting: $TSFixMe) => {
      if (
        !Section.isPrivate(meeting.section) &&
        meeting.section.isBuyable &&
        (!meeting.section.activity.is_ongoing_weekly ||
          (dayjs(meeting.start_time).isSame(
            meeting.section.nextOngoingMeeting.start_time,
            "week"
          ) &&
            dayjs(meeting.start_time).isAfter()))
      ) {
        return [...acc, normalizeScheduledMeeting(meeting)];
      }

      return acc;
    },
    []
  );

  const flexEvents: NormalizedEventInfo[] = flexSections.reduce(
    (acc: $TSFixMe, section: $TSFixMe) => {
      if (!Section.isPrivate(section) && section.isBuyable) {
        return [...acc, normalizeFlexMeeting(section)];
      }

      return acc;
    },
    []
  );

  return [...scheduledEvents, ...flexEvents];
};
